module.exports = __webpack_public_path__ + "img/wzry.eafba581.jpg";